<div class="sticky-wrapper">
  <header class="site-header">
    <div class="container-fluid">
      <div class="row justify-content-between">
        <div class="col-lg-10 col-md-9 col-sm-6 col-5">
          <a [href]="whitelabelCommericalUrl" class="custom-logo-link" rel="home" aria-current="page"
            target="_blank"><img [src]="whiteLabelLogo" class="custom-logo" [alt]="whiteLabelName"></a>
        </div>
        <div class="header-mobile-menu col-lg-2 col-md-3 col-sm-6 col-7" *ngIf="!isSuccessPage">
          <select class="form-control" [(ngModel)]="languageId" (change)="onLanguageChange($event.target.value)"
            id="languageId">
            <option *ngFor="let language of languagesList" [value]="language.id">{{ language.name }}</option>
          </select>
        </div>
      </div>
    </div>
  </header>
</div>